






















import {Component, Vue, Watch} from "vue-property-decorator";
import * as storeHelper from '@/store/store.helper';
import {DocumentsModule, UsersModule, RouterModule} from '@/store/store.helper';
import {NAVBAR_SIDE_ICON, NavBarInterface} from "@/store/types";
import * as enums from '@/types/enums';
import {MiniUserInterface} from "@/types/interfaces";
import coloredSvg from '@/components/colored.svg/colored.svg.vue';

@Component({
  name:"Counters",
  components:{
    coloredSvg
  }
})

export default class Counters extends Vue {

  @UsersModule.UsersGetter 
  private user: MiniUserInterface;
  @RouterModule.RouterGetter 
  private pathByName;
  @RouterModule.RouterAction 
  private push;
  @storeHelper.ArgumentsModule.ArgumentsGetter
  private argumentsSize: () => number;
  @storeHelper.CommentsModule.CommentsGetter
  private commentsSize: () => number;
  @storeHelper.SectionsModule.SectionsAction
  private getSizeByStatus: (number) => number;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentAllowedUsers;
  @storeHelper.UsersModule.UsersGetter
  private participantsSize: number;
  @storeHelper.RouterModule.RouterGetter
  private currentRoute;
  @storeHelper.DisplayModule.DisplayMutation 
  private setNavBar;
  @storeHelper.RouterModule.RouterGetter
  private getPath: (object) => string;

  private inTheVoteSize: number = 0;
  public counterParticipants: number = 0;
  private approvedSize: number = 0;

  @Watch('user')
  onChangeParticipantsSize(user: MiniUserInterface) {
    // If user exist. Verify user include in Document
    if(this.user.notifications?.mailAddress){
      this.updateCounterParticipants()
    }
  }

  get isUsersListPage(){
    return this.$route.name === enums.ROUTE_NAME.usersList
  }

  private async mounted() {
    this.getSizes();
    // If user exist. Verify user include in Document
    if(this.user.notifications?.mailAddress){ 
      this.updateCounterParticipants()
    }else {
      this.counterParticipants = this.participantsSize
    }
    
  }

  private voteOnNewSections(): void {
    const navbar = { path: this.currentRoute.fullPath };
    console.log('Counters.vue Set navbar ' + JSON.stringify(navbar));
    this.setNavBar(navbar);
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        sectionsByStatus: enums.SECTION_STATUS.inTheVote,
      },
    });
    console.log('Counters.vue Push path ' + path);
    this.push({ path });
  }


  public async getSizes() {
    const inTheVote = await this.getSizeByStatus(enums.SECTION_STATUS.inTheVote);
    const toEdit = await this.getSizeByStatus(enums.SECTION_STATUS.toEdit);
    this.inTheVoteSize = inTheVote + toEdit;
    console.log('Counters.vue inTheVoteSize = ' + this.inTheVoteSize);
    const approved = await this.getSizeByStatus(enums.SECTION_STATUS.approved);
    const edited = await this.getSizeByStatus(enums.SECTION_STATUS.edited);
    this.approvedSize = approved + edited;
    console.log('Counters.vue approvedSize = ' + this.approvedSize);
  }

  public updateCounterParticipants (): void {
    const mailAddress = this.user.notifications.mailAddress // Email currentUser
    let authorized = 0
    if(this.documentAllowedUsers){
      const IsUserInDocumentAllowedUsers =  this.documentAllowedUsers.includes(mailAddress) // If the property exists, check the current user's email is on the user's email list.
      authorized = IsUserInDocumentAllowedUsers ? 0 : 1;
    }
    this.counterParticipants = this.participantsSize - authorized // update counter participants
  }

  public to (){
    const path = this.pathByName(enums.ROUTE_NAME.usersList);
    this.isUsersListPage || this.push({ path });
  }
}
